import React from 'react'
import Input from './../input'
import { HOSTS, httpauth_src_fields, httpauth_dest_fields } from './../../lib/helper'
import { PanelGroup, Panel, OverlayTrigger, Tooltip } from 'react-bootstrap'
import _ from 'underscore'

class AdvancedOptionsForm extends React.Component{
	constructor(props){
		super(props)
		this.state = {}
		this.getClassName = this.getClassName.bind(this)
		this.fetchValue = this.fetchValue.bind(this)
		this.handleSelect = this.handleSelect.bind(this)
		this.showDirectoryList = this.showDirectoryList.bind(this)
		this.showTablesList = this.showTablesList.bind(this)
	}

	componentWillMount(){
		const { errors } = this.props
		this.setAdvancedOptionsError(errors)
	}

	UNSAFE_componentWillReceiveProps(nextProps){
		const { errors } = nextProps
		const olderrors = this.props.errors
		if (!_.isEqual(errors, olderrors)){
			this.setAdvancedOptionsError(errors)
		}
	}

	setAdvancedOptionsError(errors){
		if (!_.isEmpty(_.intersection(errors, httpauth_src_fields))){
			this.setState({ activeKey: "1" })
		} else if (!_.isEmpty(_.intersection(errors, httpauth_dest_fields))){
			this.setState({ activeKey: "2" })
		}
	}

	handleSelect(activeKey) {
		let _key = this.state.activeKey
		if (_key && _key == activeKey) {
			this.setState({ activeKey: false })
		} else {
			this.setState({ activeKey: activeKey })
		}
	}

	getClassName(key){
		const { errors } = this.props
		let className = "col-md-12 col-xs-12"
		if (_.contains(errors, key)){
			className += " error-field"
		}
		return className
	}

	fetchValue(key){
		const { fields } = this.props
		let value = fields[key] || ""
		return value
	}

	showDirectoryList() {
		const { directoryList, changeSelection, directoriesSelectAllDisabled, allDirectoriesSelected, selectAllDirectories } = this.props
		if (directoryList) {
			let list = directoryList.map((directory, index) => {
				return <li key={index} style={{listStyle: "none"}}>
					<label className="control control--checkbox">{directory.name}
						<input
							name={directory.name}
							type="checkbox"
							checked={directory.selected}
							onChange={changeSelection.bind(null, directory.name)}
							disabled={directory.isDisabled}
						/>
						<div className="control__indicator"></div>
					</label>
				</li>
			})
			list.unshift(<li key='select-all' style={{listStyle: "none"}}>
				<label className="control control--checkbox">Select All
					<input
						namee='select-all'
						type="checkbox"
						disabled={directoriesSelectAllDisabled}
						checked={allDirectoriesSelected}
						onChange={selectAllDirectories.bind(null)}
					/>
					<div className="control__indicator"></div>
				</label>
			</li>)
			return list
		}
	}

	showTablesList() {
		const { tablesList, changeTableSelection, selectAllTables, allTablesSelected, tablesSelectAllDisabled } = this.props
		if (tablesList) {
			const tableContent = tablesList.map((table, index) => {
				return <li key={index} style={{listStyle: "none"}}>
					<label className={`control control--checkbox ${table.isDisabled ? 'disabled' : ''}`}>{table.name}
						<input
							name={table.name}
							type="checkbox"
							checked={table.selected}
							onChange={changeTableSelection.bind(null, table.name)}
							disabled={table.isDisabled}
						/>
						<div className="control__indicator"></div>
					</label>
				</li>
			})
			tableContent.unshift(<li key='select-all' style={{ listStyle: "none" }}>
				<label className="control control--checkbox">Select All
					<input
						name='select-all'
						type="checkbox"
						disabled={tablesSelectAllDisabled}
						checked={allTablesSelected}
						onChange={selectAllTables.bind(null)}
					/>
					<div className="control__indicator"></div>
				</label>
			</li>)
			return tableContent
		}
	}

	render(){
		const { activeKey } = this.state
		const { migrate, getDirectoryList, getTablesList } = this.props
		const optionalPrompt = HOSTS.DREAMHOST === migrate.toJS().destination_host ? " (Optional)" : ""

		return (<span>
			<div>
				<PanelGroup
					accordion
					id="advancedform"
					activeKey={activeKey}
					onSelect={this.handleSelect}
					bsClass="panel-group bv-accordion-list"
				>
					<Panel eventKey="1">
						<Panel.Heading bsClass="panel">
							<Panel.Title toggle>
								<span>
									Source Website Password Protected{optionalPrompt}
									{<OverlayTrigger placement="right"
										overlay={
										<Tooltip id="source_http_auth">
											If your source website is Password Protected, then please provide credentials
										</Tooltip>
										}
									>
										<i className="mdi mdi-help-circle-outline i-fix"></i>
									</OverlayTrigger>}
									{ activeKey === "1" ? <i className="mdi mdi-minus i-fix"></i> : <i className="mdi mdi-plus i-fix"></i> }
								</span>
							</Panel.Title>
						</Panel.Heading>
						<Panel.Body collapsible>
							<div className="row">
								<div className={this.getClassName('httpauth_src_user')}>
									<i className="mdi mdi-account"></i>
									<Input
										type="text"
										name="httpauth_src_user"
										title="Username"
										placeholder="Enter Username"
										classname=""
										value={this.fetchValue('httpauth_src_user')}
									/>
								</div>
							</div>
							<div className="row">
								<div className={this.getClassName('httpauth_src_password')}>
									<i className="mdi mdi-lock"></i>
									<Input
										type="password"
										name="httpauth_src_password"
										title="Password"
										placeholder="Enter Password"
										classname=""
										value={this.fetchValue('httpauth_src_password')}
									/>
								</div>
							</div>
						</Panel.Body>
					</Panel>


					<Panel eventKey="2">
						<Panel.Heading bsClass="panel">
							<Panel.Title toggle>
								<span>
									Destination Website Password Protected{optionalPrompt}
									{<OverlayTrigger placement="right"
										overlay={
										<Tooltip id="dest_http_auth">
											If your destination website is Password Protected, then please provide credentials
										</Tooltip>
										}
									>
										<i className="mdi mdi-help-circle-outline i-fix"></i>
									</OverlayTrigger>}
									{ activeKey === "2" ? <i className="mdi mdi-minus i-fix"></i> : <i className="mdi mdi-plus i-fix"></i> }
								</span>
							</Panel.Title>
						</Panel.Heading>
						<Panel.Body collapsible>
							<div className="row">
								<div className={this.getClassName('httpauth_dest_user')}>
									<i className="mdi mdi-account"></i>
									<Input
										type="text"
										name="httpauth_dest_user"
										title="Destination HTTP Auth Username"
										placeholder="Enter Destination HTTP Auth Username"
										classname=""
										value={this.fetchValue('httpauth_dest_user')}
									/>
								</div>
							</div>
							<div className="row">
								<div className={this.getClassName('httpauth_dest_password')}>
									<i className="mdi mdi-lock"></i>
									<Input
										type="password"
										name="httpauth_dest_password"
										title="Destination HTTP Auth Password"
										placeholder="Enter Destination HTTP Auth Password"
										classname=""
										value={this.fetchValue('httpauth_dest_password')}
									/>
								</div>
							</div>
						</Panel.Body>
					</Panel>


					<Panel eventKey="3">
						<Panel.Heading bsClass="panel">
							<Panel.Title toggle>
								<span>
									Advanced Options{optionalPrompt}
									{ activeKey === "3" ? <i className="mdi mdi-minus i-fix"></i> : <i className="mdi mdi-plus i-fix"></i> }
								</span>
							</Panel.Title>
						</Panel.Heading>
						<Panel.Body collapsible>
							<div className="row">
								<div className={this.getClassName('serverip')}>
									<i className="mdi mdi-server"></i>
									<Input
										type="text"
										name="dest_serverip"
										title="Server IP"
										placeholder="Enter Destination Server IP"
										classname=""
										value={this.fetchValue('serverip')}
									/>
								</div>
							</div>
							<div className="row">
								<div className={this.getClassName('nameserver')}>
									<i className="mdi mdi-server"></i>
									<Input
										type="text"
										name="nameserver"
										title="NameServer"
										placeholder="Enter NameServer"
										classname=""
										value={this.fetchValue('nameserver')}
									/>
								</div>
							</div>
						</Panel.Body>
					</Panel>

					<Panel eventKey="4" onClick={getDirectoryList}>
						<Panel.Heading bsClass="panel">
							<Panel.Title toggle>
								<span>
									Add Folders{optionalPrompt}
									{<OverlayTrigger placement="right"
										overlay={
										<Tooltip id="add_folders">
											By default we only migrate wp-content, wp-includes, wp-admin. If you want to migrate any other folder also, Please select it.
										</Tooltip>
										}
									>
										<i className="mdi mdi-help-circle-outline i-fix"></i>
									</OverlayTrigger>}

									{activeKey === "4" ? <i className="mdi mdi-minus i-fix"></i> : <i className="mdi mdi-plus i-fix"></i> }
								</span>
							</Panel.Title>
						</Panel.Heading>
						<Panel.Body collapsible>
							{this.showDirectoryList()}
						</Panel.Body>
					</Panel>

					<Panel eventKey="5" onClick={getTablesList}>
						<Panel.Heading bsClass="panel">
							<Panel.Title toggle>
								<span>
									Add Tables{optionalPrompt}
									{<OverlayTrigger placement="right"
										overlay={
										<Tooltip id="add_tables">
											By default we only migrate default WordPress tables. If you want to migrate any other tables also, Please select it.
										</Tooltip>
										}
										>
										<i className="mdi mdi-help-circle-outline i-fix"></i>
									</OverlayTrigger>}

									{activeKey === "5" ? <i className="mdi mdi-minus i-fix"></i> : <i className="mdi mdi-plus i-fix"></i> }
								</span>
							</Panel.Title>
						</Panel.Heading>
						<Panel.Body collapsible>
							{this.showTablesList()}
						</Panel.Body>
					</Panel>

				</PanelGroup>
			</div></span>
		)
	}
}

export default AdvancedOptionsForm
